module.exports = __webpack_public_path__ + "img/package-03.f0e4aecb.png";